import React, { useState } from 'react';
import { Flex, Button, Card, Typography, Select } from 'antd';

import { Course } from '../Course';
import { semesterStruct } from './struct';
import { useSelector } from 'react-redux';
import CommentModal from '../../../../../../../components/Modal/CommentModal';

const { Title, Paragraph } = Typography;

export const Semester = ({
  semesterDetail,
  updateSemester,
  // updated,
  evaluatePlaning,
  semesterLoading,
  status,
  semesterComments
}) => {

  const _static = useSelector((state) => state.static);
  const { staticData } = _static;

  const { evaluation_status: evaluationStatus } = staticData;


  const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
  const handleCommentModalVisible = (el) => setIsCommentModalVisible(el);
  const [comment, setComment] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(status);


  const { semester, apa_point } = semesterDetail;
  const courses = semesterDetail?.data || [];

  const handleStatusChange = (value) => {
    setSelectedStatus(value); // Update the selected status state

    if (value === 2 || value === 4) {
      handleCommentModalVisible(true);
    }
  };


  const handleCommentSubmit = () => {
    if (comment.trim()) {
      handleCommentModalVisible(false);
    } else {
      alert("Comment is mandatory for Rejected and Requested statuses.");
    }
  };

  const handleCancel = () => {
    handleCommentModalVisible(false);
    setSelectedStatus(status); // Reset to the previous status if modal is canceled
  };



  return (
    <Card {...semesterStruct.wrapper}>
      <Flex {...semesterStruct.header}>
        <Title {...semesterStruct.title}>
          Semester~
          {semester === 1 ? 'Spring' : semester === 2 ? 'Summer' : semester === 3 ? 'Autumn' : ''}
        </Title>

        <Select
          value={selectedStatus}
          onChange={handleStatusChange}
          style={{ width: 120 }}
        >
          {evaluationStatus?.length > 0 && evaluationStatus?.map((e) => (
            <Select.Option key={e.value} value={e.value}>
              {e.label}
            </Select.Option>
          ))}
        </Select>
      </Flex>

      {semesterComments && semesterComments[semester] && (
        <Paragraph>
          <strong>Comment:</strong> {semesterComments[semester]}
        </Paragraph>
      )}

      <Course
        courses={courses}
        semesterName={semester}
        updateSemester={updateSemester}
        apaPoint={apa_point}
        status={status}
      />


      <br />

      <Flex justify='end' gap={10}>
        <Button
          {...semesterStruct.saveButton}
          loading={semesterLoading[semester]?.evaluateLoading}
          onClick={() => {
            if ((selectedStatus === 2 || selectedStatus === 4) && !comment.trim()) {
              alert("Comment is mandatory for Rejected and Requested statuses.");
              handleCommentModalVisible(true);
            } else {
              evaluatePlaning(semester, selectedStatus, comment);
            }
          }}
        >
          Submit
        </Button>
      </Flex>

      <CommentModal
        isCommentModalVisible={isCommentModalVisible}
        handleCommentSubmit={handleCommentSubmit}
        handleCancel={handleCancel}
        comment={comment}
        setComment={setComment}
      />
    </Card>
  );
};
